import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import practiceEhrImg from "../../Images/practiceehr-logo.png";
import loaderPic from "../../Images/page-loading.gif";
import Forgot from "./Forgot";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setCommentUserEmail,
  setCurrentTicketNo,
  setTicketComment,
  setUserEmail,
  setUserName,
} from "../../store/reducers/SharedLayoutDataSlice";
import { DisplayMsg } from "../../services/toastService";
import {
  GetAssigneesData,
  GetClientCustomers,
} from "../../handlers/LoadDropDdown";
import {
  setAssigneeList,
  setlClientsList,
  setlCustomersList,
  setTeamsList,
} from "../../store/reducers/AssigneeTeamDropdownSlice";
import {
  ClearSessionStorage,
  FetchData,
  removeDuplicateItems,
} from "../../utils/array";
import { EMAIL_REGEX } from "../../constants/regex";
import { setUrl } from "../../handlers";
import useClearRedux from "../../CustomHooks/useClearRedux";

// eslint-disable-next-line

let forgotChk = false;
// let assigneeArray = [];

const Login = () => {
  const dispatch = useDispatch();
  const { clearRedux } = useClearRedux();

  const [errorInfo, setErrorInfo] = useState({ email: "", password: "" });
  const EmailRef = useRef(null);
  const PasswordRef = useRef(null);
  const [userInfo, setUserInfo] = useState({ email: "", password: "" });
  const [popupForgot, setPopupForgot] = useState(false);
  const [ImgLoader, setImgLoader] = useState(false);
  const navigate = useNavigate();
  let isAllowedToSubmit = true;

  useEffect(() => {
    ClearSessionStorage();
    clearRedux();

    const keyDownHandler = (event) => {
      // &&
      if (event.key === "Enter" && forgotChk !== true && isAllowedToSubmit) {
        submitLogin();
        isAllowedToSubmit = false;
        setTimeout(() => {
          isAllowedToSubmit = true; // Re-enable submission after 3 seconds
        }, 3000);
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);

  const LoadSharedData = async () => {
    LoadClientCustomerData();

    const queryParams = new URLSearchParams({
      CP: sessionStorage.CP,
      AppUser: sessionStorage.USER,
      Reseller: sessionStorage.Reseller,
    }).toString();

    try {
      const response = await FetchData(
        `Ticket/AssigneeDropdown`,
        "Support",
        queryParams
      );

      if (response && response.succeeded) {
        LoadAssigneeData(response);
      } else {
        console.log("The current response is false is", response);
      }
    } catch (error) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "⚠️ Support Api is unable to connect to server.");
    }
  };

  const LoadClientCustomerData = () => {
    const ClientsArr = [];
    const CustomerArr = [];
    GetClientCustomers().then((res) => {
      if (res && res.data) {
        let Clients = JSON.parse(res.data);
        let Customers = JSON.parse(res.dataCustAccNum);

        Clients = removeDuplicateItems(Clients, (item) => item.ENTITY_SEQ_NUM);
        Customers = removeDuplicateItems(
          Customers,
          (item) => item.ENTITY_SEQ_NUM
        );

        const emptyData = {
          text: "-Select-",
          value: "",
        };

        ClientsArr.push(emptyData);
        CustomerArr.push(emptyData);

        Clients.forEach((client, key) => {
          const clientData = {
            text: client.DESCRIPTION,
            value: client.ENTITY_SEQ_NUM,
          };
          ClientsArr.push(clientData);
        });

        dispatch(setlClientsList(ClientsArr));

        Customers.forEach((customer, key) => {
          const customerData = {
            text: customer.ENTITY_SEQ_NUM,
            value: customer.ENTITY_SEQ_NUM,
          };
          CustomerArr.push(customerData);
        });

        dispatch(setlCustomersList(CustomerArr));
      }
    });
  };

  const LoadAssigneeData = (response) => {
    const AssigneeArr = [];
    const TeamDataArr = [];

    const Assignees = response.data.dsLogin;
    let Teams = response.data.dsTeam;

    const emptyData = {
      text: "-Select-",
      value: "",
      active: "Y", // Add active to the emptyData for consistency
    };

    const emptyTeam = {
      label: "-Select-",
      value: "",
      email: "",
    };

    AssigneeArr.push(emptyData);
    TeamDataArr.push(emptyTeam);

    Assignees.forEach((client, key) => {
      const assigneeData = {
        text: client.shortName,
        value: client.email,
        active: client.active,
      };

      if (client.Email !== "") {
        AssigneeArr.push(assigneeData);
      }
    });

    // Sort AssigneeArr: Active 'Y' at the top, 'N' at the bottom
    AssigneeArr.sort((a, b) => {
      if (a.active === "Y" && b.active !== "Y") {
        return -1; // a comes before b
      }
      if (a.active !== "Y" && b.active === "Y") {
        return 1; // b comes before a
      }
      return 0; // No change in order
    });

    dispatch(setAssigneeList(AssigneeArr));

    // assigneeArray = AssigneeArr;

    const rowClientService = Teams.map((item) => (
        item.SEQ_NUM === sessionStorage.team_seq_num &&
        item.SHORT_NAME === "CLIENT SERVICES"
      ));

    if (rowClientService[0] !== false && rowClientService.length > 0) {
      Teams = Teams.map((item) => item.SHORT_NAME === "IMPLEMENTATION");
    }

    Teams.forEach((item, key) => {
      const teamData = {
        value: item.supportTeamId,
        label: item.name,
        email: item.email,
      };
      TeamDataArr.push(teamData);
    });

    dispatch(setTeamsList(TeamDataArr));

    document.getElementById("loader").style.display = "none";
  };

  const ValidateData = (event) => {
    const curName = event.target.name;
    const curValue = event.target.value;
    switch (curName) {
      case "email":
        if (curValue.length < 1) {
          setErrorInfo((info) => ({
            ...info,
            email: "Required",
          }));
        } else {
          const check = EMAIL_REGEX.test(curValue);

          setErrorInfo((info) => ({
            ...info,
            email: check === false ? "❌ Email is not valid!" : "",
          }));
        }

        break;
      case "password":
        setErrorInfo((info) => ({
          ...info,
          password: curValue.length < 1 ? "Required" : "",
        }));
        break;
      default:
        break;
    }
  };

  const HandleChange = (e) => {
    e.preventDefault();
    const {name} = e.target;
    const currVal = e.target.value;
    switch (name) {
      case "email":
        setErrorInfo((info) => ({
          ...info,
          email: currVal.length > 0 ? "" : "Required",
        }));

        setUserInfo((userData) => ({
          ...userData,
          email: currVal,
        }));
        break;
      case "password":
        setErrorInfo((info) => ({
          ...info,
          password: currVal.length > 0 ? "" : "Required",
        }));
        setUserInfo((userData) => ({
          ...userData,
          password: currVal,
        }));
        break;
      default:
        break;
    }
  };

  const ValidateCredential = ({ email, password }) => {
    let check = true;
    const errors = { email: "", password: "" };

    if (!email) {
      errors.email = "Required";
      check = false;
    } else if (!EMAIL_REGEX.test(email)) {
      errors.email = "❌ Email is not valid!";
      check = false;
    }

    if (!password) {
      errors.password = "Required";
      check = false;
    }

    setErrorInfo(errors);
    return check;
  };

  const submitLogin = async () => {
    try {
      const email = EmailRef.current?.value || "";
      const password = PasswordRef.current?.value || "";

      setUserInfo({ email, password });

      const validate = ValidateCredential({ email, password });
      if (validate) {
        document.getElementById("loader").style.display = "block";
        const formData = new FormData();
        formData.append("USER", email);
        formData.append("PASS", password);

        const result = await fetch(setUrl("LOGIN", "LOG_IN"), {
          method: "POST",
          body: formData,
        });
        const response = await result.json();
        if (response.status === true) {
          Object.entries({
            USER: response.user,
            SEQ_NUM: response.seq_num,
            firstName: response.firstName,
            lastName: response.lastName,
            userUUID: response.UUI,
            isTrainer: response.Istrainer,
            userToken: response.token,
            type: response.type || "",
            fullAccess: response.fullAccess,
            viewOnly: response.viewOnly,
            CP: response.CP || "",
            Reseller: "N",
            PAGENAME: response.PageName,
            team_seq_num: response.team_seq_num,
            show_support: response.showsupport,
            show_implementation: response.showimplementation,
          }).forEach(([key, value]) => sessionStorage.setItem(key, value));

          dispatch(setCommentUserEmail(""));
          dispatch(setTicketComment(""));
          dispatch(setCurrentTicketNo(""));
          const fullName = `${response.firstName  } ${  response.lastName}`;
          dispatch(setUserEmail(response.user));
          dispatch(setUserName(fullName));
          await LoadSharedData();
          document.getElementById("loader").style.display = "none";

          navigate("/dashboard");
        } else {
          DisplayMsg("2", response.Message);
        }
      }
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const HandleSetForgot = (childData) => {
    document.getElementById("loader").style.display = "none";
    setPopupForgot(childData);
    forgotChk = false;
  };

  const ForgtoUser = () => {
    forgotChk = true;
    setPopupForgot(true);
  };

  return (
    <>
      {popupForgot !== false ? <Forgot parentCallback={HandleSetForgot} /> : ""}

      <div className="errorMsgPanel" />
      <div className="successMsgPanel"> Success Message </div>

      <div
        id="detail_scroll"
        className={`${ImgLoader ? "fakeLoader" : "d-none"}`}
      >
        <img src={loaderPic} alt="Loading..." />
      </div>

      <div className="container align-items-md-center d-flex h-100">
        <div className="page-center">
          <div className="row-fluid">
            <div className="col-md-12 col-sm-12">
              <form className="loginContainer">
                <div className="text-center">
                  <img src={practiceEhrImg} alt="" />
                </div>
                <h2 className="text-center">Support / Implementation Portal</h2>

                <div className="form-outline mb-4">
                  <label
                    className="form-label font-medium"
                    htmlFor="form2Example1"
                  >
                    Email address:
                  </label>

                  {/* onFocus={(e) => ValidateData(e)} */}

                  <input
                    type="email"
                    ref={EmailRef}
                    name="email"
                    id="form2Example1"
                    className="form-control"
                    value={userInfo.email}
                    onBlur={(e) => ValidateData(e)}
                    onChange={(e) => HandleChange(e)}
                  />
                  <span className="requiredFld text-red-500 text-xs">
                    {errorInfo.email}
                  </span>
                </div>

                <div className="form-outline mb-4">
                  <label
                    className="form-label font-medium"
                    htmlFor="form2Example2"
                  >
                    Password:
                  </label>
                  <input
                    type="password"
                    ref={PasswordRef}
                    name="password"
                    id="form2Example2"
                    value={userInfo.password}
                    onBlur={(e) => ValidateData(e)}
                    onChange={(e) => HandleChange(e)}
                    className="form-control"
                  />
                  <span className="requiredFld text-red-500 text-xs">
                    {errorInfo.password}
                  </span>
                </div>

                <div className="row">
                  <div className="col-md-12 text-center">
                    <button
                      type="button"
                      className="btn btn-primary btn-block mb-4"
                      onClick={submitLogin}
                    >
                      Sign in
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-md-12 text-center"
                    onClick={() => ForgtoUser()}
                  >
                    <span role="button">Forgot password?</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
